export const environment = {
  production: false,
  wwwHome: 'https://dev-www.wd-im.de/',
  gqlHttpUrl: 'https://dev-www.wd-im.de/graphql',
  gqlWsUrl: 'wss://dev-www.wd-im.de/graphql',
  uriHttpUrl: 'https://dev.wd-im.de/graphql',
  uriWsUrl: 'wss://dev.wd-im.de/graphql',
  keycloakUrl: 'https://auth.wd-im.de',
  keycloakRealm: 'wdim',
  keycloakClientId: 'wdim-web',
};
